import React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { withTheme } from "@emotion/react";

const logTypes = [
  { value: "edn", label: "EDN" },
  { value: "picklist", label: "Picklist" },
  { value: "po", label: "Purchese Order" },
  { value: "cctv", label: "CCTV" },
  { value: "products", label: "Products" },
  { value: "vending", label: "Vending Machine" },
];

const LogTypeSelector = ({ value, handleTypeChange }) => (
  <FormControl sx={{ m: 1, width: 300, height:55 , background: "white",borderRadius:1 }}>
    <InputLabel id="demo-simple-select-label" >Type</InputLabel>
    <Select
      sx={{ height: 55}}
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={value}
      name="logType"
      onChange={(e) => handleTypeChange(e)}
    >
      {logTypes.map((type) => (
        <MenuItem key={type.value} value={type.value}>
          <ListItemText primary={type.label} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
export default LogTypeSelector;
